(() => {
  const q = (s, c = document) => c.querySelector(s);
  const qa = (s, c = document) => [...c.querySelectorAll(s)];

  function initMenu() {
    const panel = q('[data-mobile-panel]');
    const open = q('[data-menu-open]');
    const close = q('[data-menu-close]');
    if (!panel || !open) return;
    const set = (value) => {
      panel.classList.toggle('is-open', value);
      document.body.classList.toggle('menu-open', value);
      open.setAttribute('aria-expanded', String(value));
    };
    open.addEventListener('click', () => set(true));
    close?.addEventListener('click', () => set(false));
    panel.addEventListener('click', (e) => { if (e.target === panel) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
  }

  function initAnnouncement() {
    qa('[data-announcement-close]').forEach((button) => {
      button.addEventListener('click', () => button.closest('.announcement')?.remove());
    });
  }

  function initSliders(scope = document) {
    qa('[data-slider]', scope).forEach((slider) => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const slides = qa('[data-slide]', slider);
      const dots = qa('[data-dot]', slider);
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const speed = Number(slider.dataset.speed || 5000);
      const autoplay = slider.dataset.autoplay === 'true';
      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
        dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
      };
      const stop = () => window.clearInterval(timer);
      const start = () => { stop(); if (autoplay) timer = window.setInterval(() => show(index + 1), speed); };
      q('[data-prev]', slider)?.addEventListener('click', () => { show(index - 1); start(); });
      q('[data-next]', slider)?.addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot, n) => dot.addEventListener('click', () => { show(n); start(); }));
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      start();
    });
  }

  function money(cents) {
    const value = (cents / 100).toFixed(2);
    const format = window.BaytTheme?.moneyFormat || '{{amount}}';
    return format.replace(/{{\s*amount(_no_decimals)?\s*}}/, value).replace(/\.00(?=\D|$)/, '');
  }

  function initVariants(scope = document) {
    qa('[data-product-form]', scope).forEach((wrapper) => {
      if (wrapper.dataset.ready) return;
      wrapper.dataset.ready = 'true';
      const data = q('[data-variant-json]', wrapper);
      const input = q('[name="id"]', wrapper);
      const button = q('[name="add"]', wrapper);
      const price = q('[data-product-price]', wrapper);
      if (!data || !input) return;
      let variants = [];
      try { variants = JSON.parse(data.textContent); } catch (_) { return; }
      const selects = qa('[data-option-select]', wrapper);
      const update = () => {
        const values = selects.map((select) => select.value);
        const variant = variants.find((item) => item.options.every((option, i) => option === values[i]));
        if (!variant) return;
        input.value = variant.id;
        if (price) price.textContent = (variant.price / 100).toLocaleString('en-US', { maximumFractionDigits: 0 }) + ' جنيه';
        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? 'أضف إلى السلة' : 'غير متوفر';
        }
      };
      selects.forEach((select) => select.addEventListener('change', update));
    });
  }

  function toast(message) {
    const box = q('[data-toast]');
    if (!box) return;
    box.textContent = message;
    box.classList.add('is-visible');
    window.clearTimeout(box._timer);
    box._timer = window.setTimeout(() => box.classList.remove('is-visible'), 2600);
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(window.BaytTheme.routes.cartJson, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      qa('[data-cart-count]').forEach((el) => el.textContent = cart.item_count);
    } catch (_) {}
  }

  function initAjaxAdd(scope = document) {
    qa('.quick-add-form', scope).forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = q('button[type="submit"]', form);
        if (!button || button.disabled) return;
        const old = button.textContent;
        button.disabled = true;
        button.textContent = 'جارٍ الإضافة...';
        try {
          const response = await fetch(window.BaytTheme.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error();
          await refreshCartCount();
          toast('تمت إضافة المنتج إلى السلة');
          button.textContent = 'تمت الإضافة ✓';
        } catch (_) {
          form.submit();
          return;
        }
        window.setTimeout(() => { button.disabled = false; button.textContent = old; }, 1300);
      });
    });
  }

  function initSort() {
    q('[data-sort-by]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });
  }

  function init(scope = document) {
    initMenu();
    initAnnouncement();
    initSliders(scope);
    initVariants(scope);
    initAjaxAdd(scope);
    initSort();
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
